export default __webpack_public_path__ + "static/media/rmcm06.934a5f78.png";